import { gql } from '@src/lib/gql'

/**
 * Booking form read (L2): `advisorSessionPricing` is the only guest-readable price
 * (`ScoAdvisorProfile.hourlyRate` is null for guests). The profile supplies the name,
 * photo and preferred hours; never read `hourlyRate` from it for booking.
 */
export const ADVISOR_SESSION_BOOK_EXPERT = gql`
  query AdvisorSessionBookExpert($userId: String!) {
    advisorSessionPricing(expertUserId: $userId) {
      expertUserId
      hourlyRate
      defaultMinutes
      minMinutes
      maxMinutes
      packages {
        minutes
        priceUsd
      }
    }
    advisorProfile(userId: $userId) {
      id
      advisorProfileId
      canAcceptSessions
      timezone
      sessionWeeklyHours
      user {
        id
        userId
        fullName
        displayName
        pictureUrl
      }
    }
  }
`
